import { render } from "./myPage.vue?vue&type=template&id=29a4a828&scoped=true&ts=true"
import script from "./myPage.vue?vue&type=script&lang=ts&config=true"
export * from "./myPage.vue?vue&type=script&lang=ts&config=true"

import "./myPage.vue?vue&type=style&index=0&id=29a4a828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a4a828"]])

export default __exports__